module.exports = __webpack_public_path__ + "img/gathering-submitted.7cec26e5.jpg";